import debug from "debug";
import plugin from '../../lib/plugin';

export const MODULE_NAME = 'app.core/modules/store-locator-map';
export const ELEMENT_SELECTOR = '[data-store-locator-map]';

const log = debug(MODULE_NAME);


export function exec() {
    const elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) { return; }
    const { StoreLocatorMap } = require('./component');
    plugin('storeLocatorMap', StoreLocatorMap);
    $(elements).storeLocatorMap();
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-locator-map/index.js